import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default () => {
  useGSAP(() => {
    gsap.timeline({
      defaults: {
        duration: 1,
        delay: 3,
        ease: 'power4.in'
      },
      scrollTrigger: {
        trigger: "#icon-pin",
        start: "top center",
        end: "bottom center",
        markers: false,
        toggleActions: "play none play reset"
      }
    }).fromTo('.package', {
        duration: .3,
        x: 0,
        y: -10,
        opacity: 0,
      }, {
        x: 0,
        y: 0,
        opacity: 1,
      })
    });

 return (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.16 109.42" id="icon-pin">
		<g className="icon-pin" fill="none" stroke="#001e5d" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4">
			<path d="M86.16 44.09C86.16 20.85 67.32 2 44.08 2S2 20.85 2 44.09c0 5.33 1.03 10.4 2.84 15.1 0 0 1.51 13.03 39.24 48.23 37.18-32.88 39.25-48.23 39.25-48.23 1.8-4.69 2.83-9.77 2.83-15.1Z"/>
			<path d="M75.29 44.08c0 17.24-13.98 31.22-31.21 31.22S12.87 61.32 12.87 44.08s13.97-31.22 31.21-31.22 31.21 13.98 31.21 31.22Z"/>
			<g className="package">
				<path d="M59.66 59.37H28.5c-.86 0-1.56-.7-1.56-1.56V34.44h34.28v23.37c0 .86-.7 1.56-1.56 1.56Z"/>
				<path d="m48.6 46.66-4.52-2.87-4.52 2.87a.78.78 0 0 1-1.27-.61V34.44h11.58v11.61c0 .65-.76 1.02-1.27.61Zm5.64-20.01H33.92c-.47 0-.92.22-1.22.58l-5.76 7.21h34.28l-5.76-7.21c-.3-.37-.74-.58-1.22-.58Z"/>
				<path d="M46.75 26.65h-5.34l-3.12 7.79h11.58l-3.12-7.79z"/>
			</g>
		</g>
	</svg>
 );
}